<template>

	<div>

		<div class="tabContentSection" v-if="!isDeleting" :key="variant">

			<div class="tabContentSectionBlock">
				<small>angelegt am {{ formatDate2(variant.created) }} von {{ variant.createdBy.username }}</small>
			</div>

			<div class="centered bg-light" style="max-width: 800px; margin: 0 auto; border-radius: 4px;">

				<template v-if="variant.type.name == 'FACEBOOK'">

					<div class="publication" style="margin: 0 auto; max-width: 700px;">

						<div class="control is-grouped">

							<!-- SCHEDULE DATE -->
							<div class="control">
								<div class="control-label">
									<label-name :labelKey="'CPC-VARIANT-'+variant.type.name+'-SCHEDULE-DATE'"></label-name>
								</div>
								<div class="control">
									<datepicker placeholder="Datum wählen" :options="datePickerOptions2" v-model="variant.scheduleDate" :class="{ 'is-disabled': ['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1 }"></datepicker>
								</div>
							</div>
						</div>

					</div>

				</template>

				<template v-else-if="['TEASER_INTERNAL', 'NEWSLETTER'].indexOf(variant.type.name) > -1">

					<template v-if="!newsletters">
						<!-- || newsletters.length == 0 -->
						<loading-indicator-pulse class="small" style="margin: 0 auto;"></loading-indicator-pulse>

					</template>

					<template v-else>

						<div class="publication" style="margin: 0 auto; max-width: 700px;">

							<div class="control is-grouped">

								<!-- SCHEDULE DATE -->
								<div class="control">
									<div class="control-label">
										<label-name :labelKey="'CPC-VARIANT-'+variant.type.name+'-SCHEDULE-DATE'"></label-name>
									</div>
									<div class="control">
										<datepicker placeholder="Datum wählen" :options="datePickerOptions2" v-model="variant.scheduleDate" :class="{ 'is-disabled': ['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1 }"></datepicker>
									</div>
								</div>
							</div>

						</div>

						<div class="publication" style="margin: 0px auto; max-width: 700px;">

							<div class="control is-grouped">
								<form-input inputType="select" :showLabel="false" label="CPC-VARIANT-SELECT_NEWSLETTER" showLabelInOptions="false" :selectOptions="newsletterOptions" v-model="newsletterSelected" :selectIsDisabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"></form-input>
								<span :class="['button', { 'is-disabled': newsletterSelected == null }]" @click="newsletterAdd">Newsletter übernehmen</span>
							</div>

							<template v-if="newslettersDraft.length > 0">
								<strong><lang labelKey="CPC-VARIANT-NEWSLETTER_DRAFT"></lang></strong>
								<ul>
									<li v-for="newsletter in newslettersDraft">
										{{ newsletter.name }}
										<small>in <i>{{ newsletter.channel.name }}</i></small>
									</li>
								</ul>
							</template>

							<template v-if="newslettersSent.length > 0">
								<br />
								<strong><lang labelKey="CPC-VARIANT-NEWSLETTER_SENT"></lang></strong>
								<ul>
									<li v-for="newsletter in newslettersSent">
										{{ newsletter.name }}<br />
										<small>versendet am {{ formatDate2(newsletter.sendDate) }} in <i>{{ newsletter.channel.name }}</i></small>
									</li>
								</ul>
							</template>

						</div>

					</template>

				</template>

				<template v-else>

					<div v-for="publication in variant.publications" :key="publication.articleVariant" class="publication" style="margin: 0 auto; max-width: 700px;">

						<div class="control is-grouped">

							<template v-for="pubField in publication.channel.data.publicationFields">

								<!-- DATE -->
								<template v-if="pubField.type == 'date'">

									<div class="control">
										<div class="control-label">
											<label-name :labelKey="'CPC-VARIANT-'+variant.type.name + '-PUBLICATION-DATE-' + pubField.field.toUpperCase()"></label-name>
										</div>
										<div class="control">
											<datepicker placeholder="Datum wählen" :options="datePickerOptions" v-model="publication[pubField.field]" :class="{ 'is-disabled': ['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1 }"></datepicker>
										</div>
									</div>

								</template>

								<!-- SELECT -->
								<template v-else-if="pubField.type == 'select'">

									<template v-if="selectOptionsIsLoading">
										<loading-indicator-pulse class="small"></loading-indicator-pulse>
									</template>

									<template v-else>
										<form-input inputType="select" maxWidth="250px" :label="'CPC-VARIANT-' + pubField.field.toUpperCase()" :showLabelInOptions="false" :selectOptions="selectOptions[getSelectOptionsField(pubField)]" v-model="publication[pubField.field]" :selectIsDisabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"></form-input>
									</template>

								</template>

							</template>

						</div>

					</div>

				</template>

			</div>

			<div :class="['statusBlock', variant.status != null ? variant.status.name : 'DEFAULT']">

				<div class="centered">

					<div class="control is-grouped">

						<!-- STATUS -->
						<form-input label="CPC-VARIANT-STATUS" :selectAllowEmpty="false" :showLabel="true" inputType="select" :selectOptions="articleVariantStatus" v-model="variant.status" :is-horizontal="false" :selectIsDisabled="statusSelectorIsDisabled"></form-input>

						<!-- ASSIGNEE -->
						<form-input label="CPC-VARIANT-ASSIGNEE" maxWidth="250px" inputType="select" :selectIsSearchable="true" :selectOptions="users" selectCustomLabel="customLabel" selectFieldName="username" :showLabelInOptions="false" v-model="variant.assignee" :is-horizontal="false"></form-input>

						<!-- DEADLINE -->
						<div class="control">
							<div class="control-label">
								<label-name labelKey="CPC-VARIANT-DEADLINE"></label-name>
							</div>
							<div class="control">
								<datepicker placeholder="Datum wählen" :options="datePickerOptions" v-model="variant.deadline"></datepicker>
							</div>
						</div>

					</div>

				</div>
			</div>


			<div class="centered">

				<div class="control" v-if="takeOverOptions.length > 0">
					<div class="control-label">
						<label-name labelKey="CPC-VARIANT-TAKEOVER_FIELDS"></label-name>
					</div>
					<div class="control">
						<multiselect
							v-model="takeOverField"
							:options="takeOverOptions"
							label="TAKE_OVER_FIELD"
							:custom-label="takeOverCustomLabel"
							deselect-label="Klick um abzuwählen"
              selectLabel="Klick um auszuwählen"
              selectedLabel="ausgewählt"
              :placeholder="$t('SELECT_BOX-TAKEOVER-PLEASE_SELECT')"
							track-by="id"
							@select="onTakeOverSelect"
							:disabled="activeUser.userRole.name == 'Agentur Layouter'"
							class="singleSelect">
						</multiselect>
					</div>
				</div>

				<br />

				<template v-for="field in variant.type.data.fields">

					<!-- STRING and SELECT FIELDS -->
					<template v-if="['string', 'select'].indexOf(field.type) > -1">
						<form-input :label="'CPC-VARIANT-' + variant.type.name + '-' + field.field.toUpperCase()" :inputType="getFieldType(field.type)" v-model="variant[field.field]" :is-horizontal="false"></form-input>
					</template>

					<!-- ASSET FIELDS -->
					<template v-else-if="field.type == 'asset'">

						<div class="control asset">

							<div class="control-label">
								<label-name :labelKey="'CPC-VARIANT-'+variant.type.name + '-' + field.field.toUpperCase()"></label-name>
							</div>

							<div class="control">

								<div :ref="field.field" class="teaserImage lazy-img-fadein" v-lazy:background-image="imagePath(variant[field.field])" @click="imagePoolOpen(field.field, field.crop)">

									<template v-if="variant[field.field] != null">
										<div class="imgOptions">
											<span class="icon is-small imageCrop" @click.prevent.stop="cropImage(variant, field)" v-if="field.crop">
												<i class="fa icon-ak-bearbeiten" title="crop"></i>
											</span>
											<pop-confirm class="icon is-small imageRemove" content="Möchten Sie dieses Bild wirklich entfernen?" cancel-text="nein" ok-text="ja" :on-ok="function() { imageRemove(variant, field) }">
												<i class="fa icon-ak-entfernen" title="Bild entfernen"></i>
											</pop-confirm>
										</div>
									</template>

								</div>

							</div>
						</div>

					</template>


					<!-- FROALA TEXT FIELDS -->
					<template v-else-if="field.type == 'text'">

						<div class="control">
							<div class="control-label">
					            <label-name :labelKey="'CPC-VARIANT-'+variant.type.name + '-' + field.field.toUpperCase()"></label-name>
					        </div>
							<div class="control froalaRTE froalaPlain">
								<froala id="froala" ref="froala" :tag="'textarea'" :config="froalaConfig" v-model="variant[field.field]"></froala>
							</div>
						</div>

					</template>


					<!-- GALLERY -->
					<template v-else-if="field.type == 'gallery'">

						<div class="control" style="margin-top: 25px;">
							<div class="control-label">
					            <label-name :labelKey="'CPC-VARIANT-'+variant.type.name + '-' + field.field.toUpperCase()"></label-name>
					        </div>
							<div class="control">
								<assets :assets="variant.galleryAssets" thumbDir="thumb" :enableDragDrop="true" @removeAsset="removeGalleryItem"></assets>
							</div>
						</div>

						<span class="button is-light" @click="imagePoolOpen(field.field)"><span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span><lang labelKey="CPC-VARIANT-NEW_GALLERY_ITEM"></lang></span>

					</template>

				</template>

				<!-- <template v-if="['HERBA_IMPULSE_ONLINE'].indexOf(variant.type.name) > -1"> -->
					<div style="font-size: 11px; margin: 48px 0 24px 0; color: #666; line-height: 12px;">mit <span style="color:red;">*</span> markierte Felder sind Pflichtfelder</div>


			</div>





			<div class="tabButtons" v-if="variant.id != null">

				<template v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">

					<!-- delete button -->
					<pop-confirm content="Soll diese Variante wirklich gelöscht werden?" icon="question-circle-o" :on-ok="function() { variantDelete(variant) }">
						<custom-button name="CPC-VARIANT-DELETE" type="dark" size="small" icon="icon-ak-entfernen" :class="{ 'is-disabled': variant.id == null }"></custom-button>
					</pop-confirm>

					<!-- changelog -->
					<router-link :to="{ name: 'complatContentPoolContentVariantChangeLog', params: { 'contentVariantID': variant.id, 'tab': this.variant }}" :class="{ 'is-disabled': variant.id == null }">
						<custom-button name="CPC-VARIANT-CHANGELOG" type="dark" size="small" icon="icon-ak-history" :class="{ 'is-disabled': variant.id == null}"></custom-button>
					</router-link>

				</template>

				<template v-if="variant.type.name=='HERBA_IMPULSE_ONLINE' && variant.friendlyName && variant.friendlyName != '' && variant.publications.length && variant.publications.some((pub) => pub.herbaImpulseOnlineSection != null)">
					<custom-button name="CPC-VARIANT-PREVIEW" type="dark" size="small" icon="icon-ak-preview" :class="{ 'is-disabled': variant.id == null}" @click.native="variantPreview(variant)"></custom-button>
				</template>


				<!-- export button -->
				<export-button export="articleVariant" btnTitle="CPC-VARIANT-EXPORT" btnSize="small" :exportId="variant.id ? variant.id : null" :isDisabled="variant.id == null"></export-button>

				<!--
				<template v-if="variant.type.name=='HERBA_IMPULSE_ONLINE'">
					<custom-button name="CPC-VARIANT-PREVIEW" type="dark" size="small" icon="icon-ak-preview" :class="{ 'is-disabled': !activeUser.isAdminRole && variant.id == null }" @click.native="preview(variant)"></custom-button>
				</template>
				-->

			</div>

			<!-- <pre>{{ variant }}</pre> -->
		</div>


		<div class="tabContentSection comments" v-if="variant.id != null">
			<comments v-if="variant.id != null" :threadID.sync="variant.thread" :api="'articleVariant/'+variant.id"></comments>
		</div>


		<image-pool
			:articleId="content.id"
			:assets="content.assets"
			:singleImage="imagePoolIsSingleImage"
			:show="showImagePool"
			@close="showImagePool=false"
			@selectImage="selectImagePoolImage">
		</image-pool>

		<!-- MODAL -->
		<modal
			:width="modal.width"
			:title="modal.title"
			transition="fadeDown"
			cancel-text="Abbrechen"
			:show-ok="false"
			:backdrop-closable="false"
			:is-show="showModal"
			:class="modal.type"
			@close="closeModal">

				<template v-if="modal.isLoading">
					<loading-indicator></loading-indicator>
				</template>

				<template v-else>

					<!-- PREVIEW -->
					<template v-if="modal.type == 'preview'">

						<iframe sandbox="allow-same-origin allow-scripts" :src="previewURL" style="width: 100%; height: 800px;"></iframe>

						<div slot="footer">
							<span class="button" @click="closeModal">schließen</span>
						</div>

					</template>

					<!-- IMAGE RESIZE -->
					<template v-else-if="modal.type == 'imageCrop'">
						<!-- <img :src="imageCropImage" /> -->
						<croppa
							v-model="imageCropData"
							:width="imageCropWidth"
							:height="imageCropHeight"
							:disable-click-to-choose="true"
							:disable-drag-to-move="false"
							:disable-drag-and-drop="true"
							:disable-pinch-to-zoom="true"
							:disable-rotation="true"
							:show-remove-button="false"
							:prevent-white-space="true"
							:key="imageCropImage"
							:initial-image="imageCropImage"
							@init="cropInit"
							@zoom="cropZoom">
							<!-- :initial-image="imageCropImage"> -->
								<!-- <img crossOrigin="anonymous" :src="imageCropImage" slot="initial"> -->
						</croppa>


						<div slot="footer">
							<span class="button" @click="closeModal">abbrechen</span>
							<span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="appendCroppedImage">übernehmen</span>
						</div>


					</template>

				</template>

		</modal>

	</div>


</template>

<script>
import comments from '../../utils/incl-comments';
import vue2Dropzone from '../../utils/dropzoneWrapper'
import assets from '../../utils/incl-assets'
import imagePool from './incl-imagePool'
import exportButton from '../../utils/exportButton';

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)

import { de } from 'flatpickr/dist/l10n/de';
de.firstDayOfWeek = 1; // Monday

import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa'
Vue.use(Croppa);

export default {

	components: {
		comments,
		VueFroala,
		vueDropzone: vue2Dropzone,
		imagePool,
		assets,
		exportButton
	},

	props: {

		variant: {
			type: Object,
			default: function() { return {} }
		},

		content: {
			type: Object,
			default: function() { return {} }
		},

		channels: {
			type: Array,
			default: function() { return [] }
		},

		users: {
			type: Array,
			default: function() { return [] }
		},

	},

	data() {

		return {

			isDeleting: false,
			showRawData: false,
			takeOverField: null,

			selectOptions: {},
			selectOptionsIsLoading: true,

			showImagePool: false,
			showModal: false,
			previewURL: "",

			modal: {
				isLoading: false,
				isSaving: false,
				width: '640',
				class: '',
				title: ''
			},

			newsletters: null,
			newslettersSent: null,
			newslettersDraft: null,
			newsletterSelected: null,

			imagePoolTarget: null,
			currentImage: null,
			imagePoolIsSingleImage: true,
			imageCropWidth: 400,
			imageCropHeight: 250,
			imageCropImage: null,
			imageCropData: {},

			datePickerOptions: {
				enableTime: false,
				altInput: true,
				altFormat: 'd. F Y',
				locale: de,
				clickOpens: true,
				weekNumbers: true
      },

			datePickerOptions2: {
				enableTime: true,
				time_24hr: true,
				altInput: true,
				altFormat: 'd. F Y H:i',
				locale: de,
				clickOpens: true,
				weekNumbers: true
      },

			froalaConfig: {
        key: '',
				linkAlwaysBlank: true,
				paragraphStyles: {
		          'hi-headline-caption': 'Überschrift Caption',
		          'hi-headline': 'Überschrift',
						  'hi-intro': 'Intro Text',
						  'hi-interview-question': 'Interview Frage'
        },
				specialCharactersSets: [{
					title: 'Latin',
				    list: [
				      { 'char': '&copy;', desc: 'COPYRIGHT SIGN' },
					  { 'char': '&reg;', desc: 'REGISTERED SIGN' },
				      { 'char': '&trade;', desc: 'TRADEMARK SIGN' },
				    ]
				}],

				colorsText: [],
				colorsHEXInput: false,
				colorsBackground: ['#FFFF00', 'REMOVE'],
				colorsDefaultTab: 'background',
				// , '|', 'undo', 'redo'
				// toolbarButtons: ['stylesDropdown', 'bold', 'italic', 'underline', '|', 'subscript', 'superscript', '|', 'buttonIcon', 'paragraphFormat', 'paragraphStyle', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertTable', 'customImageButton', '|', 'fullscreen'],
				// 'color',

				toolbarButtons: ['bold', 'italic', 'underline', '|', 'subscript', 'superscript', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertTable', 'customImageButton', 'insertVideo', '|', 'stylesDropdown', 'clearFormatting', '-', '|', 'specialCharacters', 'color', '|', 'undo', 'redo', '|', 'fullscreen'],
				videoUpload: false,

				placeholderText: 'Schreiben Sie hier Ihren Text ...',
        imageManagerLoadURL: '',
        imageUploadURL: '',
        imageUploadParams: { froala: 1 },
				imageInsertButtons: ['imageUpload'],

				// imageEditButtons: ['imageAlign', 'imageCaption', 'imageRemove', '-', 'imageDisplay', 'imageAlt', 'imageSize'],
				imageInsertButtons: ['imageAlign', 'imageCaption', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],

				imageDefaultWidth: 150,
				imageDefaultAlign: 'left',
				wordPasteModal: false,
				pastePlain: true,
        initOnClick: false,
        requestHeaders: {
					"Authorization": 'Basic ' + localStorage.getItem('token')
		  	},
				heightMin: 300,
				heightMax: 1024,
				quickInsertButtons: ['customImageButton', 'table', 'ul', 'ol'],
				language: 'de',
				tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
				tableMultipleStyles: false,
				tableResizer: true,
				charCounterCount: false,
				// charCounterMax: 140,
        // quickInsertTags: [],        // disable quickInsertBar
    	},

			froalaConfigFacebook: {
				toolbarButtons: ['bold', 'italic', 'underline', '|', 'insertLink'],
			}

		}

	},

	computed: {

		newsletterOptions() {

			return this.newsletters;

			var arr = [];

			this.newsletters.forEach(newsletter => {
				newsletter.name = newsletter.name + Math.random();
				arr.push(newsletter);
			})
			return arr;

		},


		statusSelectorIsDisabled() {

			// ['Agentur Chefredaktion', 'Agentur Layouter', 'Autor'].indexOf(activeUser.userRole.name) > -1
			if(['Agentur Chefredaktion', 'Agentur Layouter', 'Autor'].indexOf(this.activeUser.userRole.name) > -1) {
				return true;
			}
			else if(this.activeUser.userRole.name == 'Herba Vorstand') {

				if(['DRAFT', 'APPROVAL', 'APPROVED'].indexOf(this.variant.status.name) > -1) {
					return false;
				} else {
					return true;
				}

			}

			return false;

		},

		articleVariantStatus() {

			var articleVariantStatus = this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_STATUS');

			// #11402
			// die User der Benutzerrolle "Herba Vorstand" sollen im Status-Dropdown bitte nur die folgenden Stati sehen/auswählen können:
			// In Bearbeitung, Zur Freigabe, Freigegeben
			if(this.activeUser.userRole.name == 'Herba Vorstand') {

				for (var key in articleVariantStatus) {
			    if (!articleVariantStatus.hasOwnProperty(key)) continue;
					if(['DRAFT', 'APPROVAL', 'APPROVED'].indexOf(key) == -1) {
						delete articleVariantStatus[key];
					}
				}

				return articleVariantStatus;

			}

			// #11416
			// nur User vom Typ "Administrator" und "Herba Administrator" dürfen den Status "Bereit zur Veröffentlichung" sehen
			else if(['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(this.activeUser.userRole.name) == -1) {

				delete articleVariantStatus['READY'];
				return articleVariantStatus;

			} else {

				return articleVariantStatus;

			}

		},

		getChannels() {

			var self = this;
			var chs = [];
			this.variant.type.data.channels.forEach(function(channel) {
				chs.push(self.channels.find((ch) => ch.id == channel));
			})

			return chs;

		},


		takeOverOptions() {

			var variantsArr = "";

			// determine if the current variant is of type "Variant" or "Teaser"

			if(['HERBA_IMPULSE_PRINT', 'HERBA_IMPULSE_ONLINE', 'INTRANET', 'COOPERATE'].indexOf(this.variant.type.name)  > -1) {
				variantsArr = ['HERBA_IMPULSE_PRINT', 'HERBA_IMPULSE_ONLINE', 'INTRANET', 'COOPERATE'];
			} else {
				variantsArr = ['FACEBOOK', 'NEWSLETTER', 'TEASER_INTERNAL'];
			}

			let index = variantsArr.indexOf(this.variant.type.name);
			if(index > -1) {
				variantsArr.splice(index, 1);
			}


			var variants = [];

			// loop through all existing variants and filter the needed variant types
			this.content.variants.forEach(function(variant, index) {

				if(variantsArr.indexOf(variant.type.name) > -1) {
					let newObj = {
						id: variant.id,
						name: variant.type.name,
						refIndex: index
					}
					variants.push( newObj );
				}

			})

			return variants;

		}

	},


	created() {

		// add video support for uploaded mp4 files
		$.FE.VIDEO_PROVIDERS.push(
			  {
				test_regex: /^.+(marketingserver.at)\/[^_&]+/,
				url_regex: '',
				url_text: '',
				html: '<video width="640" height="360" autobuffer controls><source src="{url}" type="video/mp4"><div>Das Video kann leider nicht angezeigt werden, da Ihr Browser kein HTML5 unterstützt. Vielleicht wollen Sie auf eine zeitgemäße Version Ihres Browsers aktualisieren?</div></video>',
				// html: '<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
				provider: 'marketingserver'
			  },
		);

		/*
		// if there was no assignee set, set it to the creator himself
		if(this.variant.assignee == null) {
			this.variant.assignee = this.variant.createdBy;
			this.variant.assignee.customLabel = this.variant.createdBy.person.fullName;
		}
		*/

		// set licence key for froala
		this.froalaConfig.key = this.$config.froalaKey;

		var self = this;

		// initialize custom buttons for froala RTE
    $.FroalaEditor.DefineIcon('customImageButton', { NAME: 'image'});
		$.FroalaEditor.DefineIcon('highlightButton', { NAME: 'star'});

		// register custom image button
    $.FroalaEditor.RegisterCommand('customImageButton', {
        title: 'neues Bild einfügen',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function () {
					this.selection.save();			// save current cursor selection
					self.imagePoolOpen('froala');	// open image pool modal
      	}
    });

		// register custom Image quick insert button
		$.FroalaEditor.RegisterQuickInsertButton('customImageButton', {
			icon: 'customImageButton',
			title: 'neues Bild einfügen',
			focus: false,
			undo: false,
			refreshAfterCallback: false,
			callback: function () {
				this.selection.save();			// save current cursor selection
				self.imagePoolOpen('froala');	// open image pool modal
			}
		});

		/*
		// register text marker button
	    $.FroalaEditor.RegisterCommand('highlightButton', {
	        title: 'text marker',
			icon: 'highlightButton',
	        focus: true,
	        undo: true,
	        refreshAfterCallback: false,
	        callback: function ($btn) {
				this.format.applyStyle('background-color', 'yellow');
	        },
			refresh: function ($btn) {
				$btn.addClass('fr-active');
				this.selection.element();
				// The current context is the editor instance.
				// console.log (this.selection.element());
			}
	    });
		*/


		/**************************************************/

		$.FroalaEditor.DefineIcon('stylesDropdown', { NAME: 'cog'} );
		$.FroalaEditor.RegisterCommand('stylesDropdown', {
			title: 'Formatierungen',
			type: 'dropdown',
			focus: true,
			undo: true,
			refreshAfterCallback: true,

			options: {
				'o3': 'Absatz Überschrift',
				'o4': 'Intro',
				'o5': 'Interview Frage',
				'o7': 'Zitatbox',
				'o8': 'Infobox',
				'o10': 'Reset'
			},

			callback: function (cmd, val) {

				switch(val) {

					/*
					// headline caption
					case "o1":
						this.paragraphFormat.apply('h2 class="hi-headline-caption"');
						break;

					// headline
					case "o2":
						this.paragraphFormat.apply('h1 class="hi-headline"');
						break;
					*/

					// paragraph headline
					case "o3":
						this.paragraphFormat.apply('h3 class="hi-element hi-paragraphTitle"');
						break;

					// intro
					case "o4":
						this.paragraphFormat.apply('div class="hi-element hi-intro"');
						break;

					// interview
					case "o5":
						this.paragraphFormat.apply('div class="hi-element hi-interview-question"');
						break;

					// quotation
					case "o7":
						// this.paragraphFormat.apply('div class="hi-quotation"');
						this.html.insert(
							'<div class="hi-element hi-quotation">' +
								'<div class="quotationMarkTop">&bdquo;</div>' +
								'<div class="lead">Paulina Fellhofer (22) hat mehrere Jahre Medikamente zur Behandlung von Morbus Crohn eingenommen</div>' +
								'<div class="detail">Gerade wenn sich bei der Medikation etwas geändert hat, war es mir wichtig, dass mir der Apotheker den Behandlungsplan noch einmal erklärt hat. Ich war auch ...</div>' +
								'<div class="quotationMarkBottom">&ldquo;</div>' +
							'</div>', true);
						break;

					// infobox
					case "o8":
						/*
						//this.selection.apply('div', { class: 'hi-infobox' });
     					//this.selection.save();

						// let html = this.selection.get();
						// console.log("html: ", html);
					    // this.html.insert('<div class="hi-infobox">' + html + '</div>');

						// $(this.selection.element()).wrapAll('<div class="hi-infobox"></div>')
						*/

						this.paragraphFormat.apply('div class="hi-element hi-infobox"');
						break;

					case "o10":

						// get the start of the selection
						var selection = this.selection.blocks()[0];

						// - get the container with the class ".hi-element"
						// - get the text of the selected container
						// - save the text in the text var
						// - remove the whole .hi-element container afterwards

						// the selected container already is the parent container
						if( $(selection).hasClass("hi-element")) {
							var text = $(selection).text();
							$(selection).remove();

						// the selected container is not the parent container, get the parent container
						} else {
							var text = ($(selection).parents(".hi-element")).text();
							$(selection).parents(".hi-element").remove();
						}

						// insert the text without any markup (apart from <p></p> tags)
						this.html.insert('<p>' + text + '</p>', true);

						break;
				}


			},

			// Callback on refresh.
			refresh: function ($btn) {
				/*
				var blocks = this.selection.blocks();
				var blk = null;
				if (blocks.length) {
					var blk = blocks[0];
				}

				$btn.toggleClass('fr-active', blk && blk.tagName == 'H2');
				*/

			},

			// Callback on dropdown show.
			refreshOnShow: function ($btn, $dropdown) {

				// The current context is the editor instance.
				// console.log (this.selection.element());

			}

		});


		this.getChannels.forEach(function(channel) {

			var publication = self.variant.publications.find((ch) => ch.channel.id == channel.id);

			// if we do not have channel in our publications array assigned yet,
			// we create it as a new object
			if(typeof publication == 'undefined') {

				publication = {
					channel: channel,
					articleVariant: self.variant.id,
				}

				self.variant.publications.push(publication);

			}


			channel.data.publicationFields.forEach(function(field) {

				if(field.type == "select") {

					// get select options for the corresponding api
					self.getSelectOptions(field.api, field.params)
						.then(function() {

							// if there already was a field with an option id,
							// we assign the whole corresponding object in order to make the multiselect box work
							if(publication[field.field] && typeof publication[field.field].id == 'undefined') {

								// find the corresponding object by id in our select options and assign it
								if(typeof self.selectOptions[field.field] != 'undefined') {
									publication[field.field] = self.selectOptions[field.field].find(option => option.id == publication[field.field] );
								}

							}

						})

				}

			})

		})


		if(['TEASER_INTERNAL', 'NEWSLETTER'].indexOf(this.variant.type.name) > -1) {

			this.fetchNewsletters(this.variant);

		}


	},


	mounted() {


	},

	methods: {

		variantPreview(variant) {

			let friendlyName = variant.friendlyName;
			// let section = variant.publications[0].herbaImpulseOnlineSection.friendlyName;

			// console.log(variant);

		 	// this.previewURL = 'https://www.herbaimpulse.at/'+section+'/article/'+friendlyName;
			let t = Date.now();
			this.previewURL = `https://www.herba-chemosan.at/${friendlyName}?type=preview&t=${t}`;

			this.showModal = true;
			this.modal.type = "preview";
			this.modal.width = '1280px';
			this.modal.title = 'Vorschau';

		},

		variantDelete(variant) {

			this.entityDelete('articleVariant', variant.id, false)
				.then((response) => {

					this.$emit('setActiveTab', 'OVERVIEW');
					let variantIndex = this.content.variants.findIndex(v => v.id == variant.id);
					this.content.variants.splice(variantIndex, 1);

				}).catch((error) => {
					console.log('Error: ', error.message);
				});

		},

		newsletterAdd() {

			var self = this;

			// make sure we got a newsletter selected
			if(this.newsletterSelected == null) {
				this.$notify.open( { content: 'Bitte wählen Sie einen Newsletter!', type: 'warning'});
				return;
			}

			// get index of selected item
			let foundIndex = this.newsletters.findIndex(newsletter => newsletter == this.newsletterSelected);

			if(foundIndex > -1) {

				// prepare element object for newsletters draft
				self.newsletterSelected.elements.push({
					content: null,
					sortorder: self.newsletterSelected.elements.length,
					articleVariant: self.variant.id
				});

				// remove from newsletters options
				self.newsletters.splice(foundIndex, 1);
				// var newslettersClone = JSON.parse(JSON.stringify(self.newsletters));
				// self.newsletters = [];

				self.axios.post(self.$config.api + 'newsletter', self.newsletterSelected)
					.then((response) => {

						// add to newslettersDraft
						self.newslettersDraft.push(self.newsletterSelected);

						// helper, otherwise multiselect options won't get updated
						setTimeout(function() {
							self.newsletterSelected = null;
							// self.newsletters = newslettersClone;
						}, 0.01);

					})

			}

		},

		removeGalleryItem(index) {

			this.variant.galleryAssets.splice(index, 1);

		},

		closeModal() {

			this.showModal = false;
			this.modal.isLoading = false;
			this.modal.iSaving = false;
			this.modal.width = 640;
			this.modal.title = '';
			this.previewURL = "";

		},

		appendCroppedImage() {

			this.modal.isSaving = true;

			this.imageCropData.generateBlob((blob) => {

				var file = new File([blob], this.currentImage.filename, { type: 'image/jpeg', lastModified: Date.now()});
        var fd = new FormData()

			  fd.append('file', file);

			  this.axios.post(this.$config.api + 'fileProcessing/upload?preset=contentPool', fd)
    			.then((response) => {

						this.modal.isSaving = false;

						var croppedImage = {
							filename: response.data.fileName,
      				path: response.data.dir,
      				uploadFilename: this.currentImage.filename
						}

						this.variant[this.imagePoolTarget] = croppedImage;
						this.variant[this.imagePoolTarget + 'Data'] = this.imageCropData.getMetadata();

						this.closeModal();

						this.imageCropImage = null;
						this.imageCropData = {};
						this.imagePoolTarget = null;
						this.currentImage = null;

  				}).catch(error => {

  					console.log('Error: ', error.message);
  					this.modal.isSaving = false;

  				});

			});
		},


		imageRemove(variant, field) {

			this.$set(variant, field.field, null);

		},

		cropInit() {

			var metaData = this.variant[this.imagePoolTarget + 'Data'];

			setTimeout(() => {
				this.imageCropData.applyMetadata(metaData);
			}, 15);

		},

		cropZoom() {

			// console.log("after zoom: ", this.imageCropData.getMetadata());

		},


		cropImage(variant, field) {

			// console.log("variant: ", variant);
			// console.log("field: ", field);

			let asset = variant[field.field];

			this.imagePoolTarget = field.field;
			this.currentImage = asset;
			this.imageCropImage = this.imagePath(asset);

			this.imageCropWidth = 580;
			this.imageCropHeight = this.imageCropWidth / parseFloat(field.crop.split(":")[0]);

			this.showModal = true;
			this.modal.type = "imageCrop";
			this.modal.title = "Bild Ausschnitt wählen";

		},


		imagePath(asset) {
			return asset == null
				? false
				: this.$config.assets + asset.path + '/' + asset.filename;
		},

		imagePoolOpen(target=null, crop=false) {
			console.log("target: ", target);
			this.imagePoolIsSingleImage = target != 'galleryAssets';
			this.showImagePool = true;
			this.imagePoolTarget = target;

			if(crop) {
				this.imageCropWidth = 580;
				this.imageCropHeight = this.imageCropWidth / parseFloat(crop.split(":")[0]);
			}

		},

		selectImagePoolImage(images) {

			if(this.imagePoolIsSingleImage == true) {
				var image = images[0];
				var imgUrl =  this.imagePath(image.asset);
			}

			// FROALA EDITOR
			if(this.imagePoolTarget == 'froala') {

				let imgId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);

				$('#froala').froalaEditor('selection.restore');
				$('#froala').froalaEditor('image.insert', imgUrl, true, { 'id': imgId, 'caption': image.asset.caption, 'alt': image.asset.altText }, null, {link: 'http://example.com/file.pdf'});

				setTimeout(function() {
					// set alt attribute
					$('[data-id="'+imgId+'"]').attr('alt', image.asset.altText);
				}, 100);

				// $('#froala').froalaEditor('image.insert', imgUrl, true, {'caption': image.asset.caption, 'alt': image.asset.altText }, null, null);
				// $('#froala').froalaEditor('image.setAlt', 'Hallo Bild!!');

				this.imagePoolTarget = null;
			}

			// GALLERY
			else if(this.imagePoolTarget == 'galleryAssets') {

				// make sure the galleryAssets array exists ...
				if(typeof self.variant.galleryAssets == 'undefined') {
					this.$set(self.variant, 'galleryAssets', []);
				}

				images.forEach((image) => {

					this.variant.galleryAssets.push({
						articleVariant: this.variant.id,
						asset: image.asset,
						sortorder: this.variant.galleryAssets.length
					});

				});

			}

			// TEASER IMAGES
			else {

				this.imageCropData = {};
				this.currentImage = image.asset;
				this.imageCropImage = this.imagePath(image.asset);

				this.showModal = true;
				this.modal.type = "imageCrop";
				this.modal.title = "Bild Ausschnitt wählen";

			}

			this.showImagePool = false;

		},


		takeOverCustomLabel(option) {

			return this.$t('SELECT_BOX-TAKEOVER-'+option.name);

		},

		onTakeOverSelect(selectedOption, id) {

			var self = this;

			this.$modal.confirm({
				title: 'Felder übernehmen',
				content: 'Sollen die leeren Felder mit dem Inhalt aus "'+ self.$t('SELECT_BOX-TAKEOVER-'+selectedOption.name) +'" befüllt werden?',
				onOk: function() {
					takeOver();
				},
				onCancel: function() {
					reset();
				},
				okText: 'ja, übernehmen',
				cancelText: 'abbrechen',
				transition: 'slideDown'
			});


			var takeOver = function() {

				// takeover headline
				if(self.variant.headline == "") {
					self.variant.headline = self.content.variants[selectedOption.refIndex].headline;
				}

				// takeover kicker
				if(self.variant.kicker == "") {
					self.variant.kicker = self.content.variants[selectedOption.refIndex].kicker;
				}

				// takeover content
				if(self.variant.content == "") {
					self.variant.content = self.content.variants[selectedOption.refIndex].content;
				}


			}

			var reset = function() {

				self.takeOverField = null;

			}


		},

		getSelectOptionsField(field) {

			return field.api + '' + (field.params ? field.params['filters[channel]'] : '');

		},

		getSelectOptions(api, params=null) {

			var appendParams = "";

			if(params != null) {

				let paramsArr = [];

				for (var k in params) {
				    if (params.hasOwnProperty(k)) {
				        paramsArr.push(k+'='+params[k]);
				    }
				}

				appendParams = '?' + paramsArr.join();

			} else {

				appendParams = "";

			}



			var self = this;
			this.selectOptionsIsLoading = true;

			return new Promise(function(resolve, reject) {

				self.axios.get(self.$config.api + api + appendParams).then(function(response) {

					let key = self.getSelectOptionsField({ 'api': api, 'params': params});
					self.selectOptions[key] = response.data[api];
					setTimeout(function() {
						self.selectOptionsIsLoading = false;
					}, 500);

					resolve(response);

				})

			})

		},

		getFieldType(type) {

			switch(type) {
				case "string":
					return "text";
				case "text":
					return "textarea";
				default:
					return type;
			}

		},

		fetchNewsletters(variant) {

			var self = this;

			let channels = variant.type.name == 'TEASER_INTERNAL' ? '13' : '7,8,9,14';

			function getNewsletters() {
				// return self.axios.get(self.$config.api + 'newsletter?include=newsletter.status,newsletter.channel,newsletter.elements&filters%5bstatus.name%5d=DRAFT&filters%5bchannel%5d='+channels+'&filters%5belements.articleVariant%5d=!'+variant.id+'&groupBy=id');
				return self.axios.get(self.$config.api + 'newsletter?include=newsletter.status,newsletter.channel,newsletter.elements&filters%5bstatus.name%5d=DRAFT&filters%5bchannel%5d='+channels+'&groupBy=id');
			}
			function getNewslettersSent() {
				return self.axios.get(self.$config.api + 'newsletter?include=newsletter.elements,newsletter.channel,newsletterElement.articleVariant,newsletter.status&filters[status.name]=SENT&orderBy=sendDate%20DESC&filters%5belements.articleVariant%5d='+variant.id);
			}
			function getNewslettersDraft() {
				return self.axios.get(self.$config.api + 'newsletter?include=newsletter.elements,newsletter.channel,newsletterElement.articleVariant,newsletter.status&filters%5bstatus.name%5d=DRAFT&filters%5belements.articleVariant%5d='+variant.id);
			}

			this.axios.all([getNewsletters(), getNewslettersSent(), getNewslettersDraft()])
				.then(self.axios.spread(function (newsletters, newslettersSent, newslettersDraft) {

					var list = [];

					newsletters.data.newsletter.forEach(nl => {

						// only push elements to the list which do not already have an element with articleVariant == variant.id
						if(!nl.elements.some(l => l.articleVariant == variant.id)) {
							list.push(nl);
						}

					});

					self.newsletters = list;

					self.newslettersSent = newslettersSent.data.newsletter;
					self.newslettersDraft = newslettersDraft.data.newsletter;

				})).catch(function(error) {
					console.log("ERROR: ", error);
				});


		}
	}


}

</script>

<style>

	.hi-intro {
		color: #2F342F;
		font-size: 20px;
		line-height: 34px;
		margin-bottom: 35px;
	}
	.hi-paragraphTitle {
		text-transform: uppercase;
		font-weight: bold;
		font-size: 24px;
		line-height: 32px;
		margin-top: 45px;
		margin-bottom: 25px;
	}
	.hi-interview-question {
		color: #2F342F;
		font-size: 18px;
		font-weight: 600;
		line-height: 26px;
		margin-bottom: 25px;
	}

	.hi-interview-answer {

	}


	.hi-quotation-with-bg {

	}

	.hi-quotation {
		background-color: #F4F4F4;
		padding: 35px 20px;
		margin: 35px 0;
		color: #2F342F;
		font-size: 16px;
		line-height: 26px;
		text-align: center;
	}
	.hi-quotation .lead {
		font-family: Sans;
		font-size: 20px;
		font-weight: 600;
	}
	.hi-quotation .detail {
		font-size: 16px;
		margin: 25px 0;
	}
	.hi-quotation .quotationMarkTop,
	.hi-quotation .quotationMarkBottom {
		font-family: Sans;
		font-weight: bold;
		font-size: 58px;
		line-height: 60px;
		text-align: center;
		padding: 0;
	}
	.hi-quotation .quotationMarkTop {
		margin-bottom: 20px;
	}
	.hi-quotation .quotationMarkBottom {
		margin-top: 20px;
	}
	.hi-infobox {
		border-top: 6px solid rgba(0,0,0,0.15);
		background-color: #F4F4F4;
		padding: 20px 10px;
		color: #000;
		font-size: 14px;
		line-height: 22px;
	}

	.control.asset {
		margin-bottom: 25px;
	}

</style>


<style scoped>

	.publication ul {
		display: block;
	    list-style: disc outside none;
		margin: 0.5em 0;
	    padding: 0 0 0 20px;
	}
	.publication ul li {


	}

	.modal.preview >>> .modal-card {
		width: 85% !important;
		min-width: 640px;
		max-height: calc(100vh - 60px) !important;
	}
	.imageCrop >>> .modal-card .modal-card-body {
		text-align: center;
	}
	.froalaRTE >>> .fr-view {
		font-family: "Open Sans", arial;
		font-size: 16px;
		line-height: 26px;
	}
	.froalaRTE >>> .fr-img-caption {
		margin-bottom: 25px;
	}
	.froalaRTE >>> .fr-img-caption .fr-inner {
		color: #2F342F;
		font-family: "Open Sans";
		font-size: 14px;
		font-style: italic;
		line-height: 19px;
		text-align: left;
		padding: 5px 0;
	}
	.froalaRTE >>> .fr-element a {
		color: green !important;
	}

	.froalaRTE >>> .fr-popup .fr-buttons {
		display: none;
	}

	.bg-light {
		padding: 20px 14px;
		background: #F5F7F9;
		margin: 5px -30px 20px -30px;
	}
	.centered {
		max-width: 700px;
		width: 100%;
		margin: 0 auto;
	}

	.bg-light .centered >>> .control > .control {
		/*margin-bottom: 0;*/
	}
	.centered >>> .control > .control {
		max-width: inherit;
	}

	.statusBlock {
		width: auto;
		padding: 10px 0 0 0;
		margin: 20px -30px;
		background: #F5F5F5;
		background: none;
		transition: border .3s ease;
		border-bottom: 15px solid #FFF;
	}
	.statusBlock.NEW {
		border-bottom-color: #CDCDD2;
	}
	.statusBlock.DRAFT {
		border-bottom-color: #76d8db;
	}
	.statusBlock.PROOF_READ {
		border-bottom-color: #f1ba84;
	}
	.statusBlock.APPROVAL {
		border-bottom-color: #84a6d4;
	}
	.statusBlock.APPROVED {
		border-bottom-color: #e996ca;
	}
	.statusBlock.LAYOUT {
		border-bottom-color: #ffec7c;
	}
	.statusBlock.READY {
		border-bottom-color: #bfe29e;
	}


	.publication:not(:last-child) {
		margin-bottom: 25px;
	}
	.froalaRTE >>> .fr-element ul,
	.froalaRTE >>> .fr-element ol {
		margin-left: 20px;
	}
	.froalaRTE >>> .fr-element ul {
		list-style-type: disc;
	}

	.teaserImage {
		position: relative;
		background-repeat: no-repeat;
	    background-position: 50% 50% !important;
	    background-size: contain;
		background-color: #F5F5F5;
	    border: 1px solid #ddd;
		border-radius: 3px;
		height: 150px;
		width: 250px;
		cursor: pointer;
	}
	.teaserImage[lazy=loading] {
	    background-size: 20% !important;
	    margin: 0;
	}
	.teaserImage[lazy=error] {
	    background-image: none !important;
	}

	.teaserImage .imgOptions {
		position: absolute;
		right: 0;
		top: 0;
		background: #f5f5f5;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 2px;
		border-bottom-left-radius: 3px;
		visibility: hidden;
		opacity:0;
	    transition: visibility .3s linear, opacity .3s linear;
	}

	.teaserImage .imgOptions .icon {
		font-size: 12px;
		width: 20px;
		height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.teaserImage .imgOptions .icon i {
		display: inline-block;
		font-size: 12px;
	}

	.teaserImage:hover .imgOptions {
		visibility:visible;
	    opacity: 1;
	}


	>>> .v-spinner {
		height: auto !important;
		max-width: 250px;
	}
	>>> .v-spinner .v-clip {
		height: 12px !important;
		width: 12px !important;
	}

</style>
